import axios from "axios"

axios.defaults.withCredentials = true;
const showDataWithPost = async (API, data) => {
    console.log("API:", API);
    console.log("Data:", data);
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/${API}`, data);
        alert(response?.data?.message);
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

export default showDataWithPost;
